var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsColumnsThree = function SvgIconsColumnsThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27 10a3 3 0 0 1 2.995 2.824L30 13v14a3 3 0 0 1-2.824 2.995L27 30H13a3 3 0 0 1-2.995-2.824L10 27V13a3 3 0 0 1 2.824-2.995L13 10h14zm-5 2h-4v16h4V12zm-6 0h-3.429c-.293 0-.534.386-.567.883L12 13v14c0 .513.22.936.505.993l.066.007H16V12zm11.429 0H24v16h3.429c.293 0 .534-.386.567-.883L28 27V13c0-.513-.22-.936-.505-.993L27.43 12z"
  }))));
};
export default SvgIconsColumnsThree;